import React, { useEffect } from "react";
import { Download } from "lucide-react";

import { EM_BREVE } from "@/components/canais/canais";
import { Button } from "@/components/ui/button";
import { VendasCleoPeriodo } from "@/features/cleo-pedidos";

import FiltroPeriodo from "../components/FiltroPeriodo";
import { Esmaecer, EsqueletoModulos } from "../components/Esqueletos";
import { buscarModulos } from "../lib/api";
import { exportarExcel } from "../lib/excel";
import { rotuloArquivo } from "../lib/periodo";
import { useDados, usePeriodo } from "../lib/usePeriodo";
import CardEmBreve from "./CardEmBreve";
import CardModulo from "./CardModulo";
import RankingLucro from "./RankingLucro";
import ResumoModulos from "./ResumoModulos";

const pct = (v) => (v == null ? "" : `${String(v).replace(".", ",")}%`);
const COLUNAS_EXCEL = [
  { header: "Módulo", value: (m) => m.nome },
  { header: "Pedidos", value: (m) => m.pedidos },
  { header: "Vendas (R$)", value: (m) => m.faturamento },
  { header: "Ticket médio (R$)", value: (m) => m.ticket_medio },
  { header: "CMV (R$)", value: (m) => m.cmv },
  { header: "CMV (% das vendas)", value: (m) => pct(m.cmv_pct) },
  { header: "Despesas (R$)", value: (m) => m.despesas },
  { header: "Lucro (R$)", value: (m) => m.lucro },
  { header: "Margem (%)", value: (m) => pct(m.margem_pct) },
  { header: "Vendas sem custo (R$)", value: (m) => m.vendas_sem_custo },
];

// Relatórios → Relatório de Módulos (refeito em 21/09/2026 a pedido do dono).
export default function ModulosTab({ definirAtualizar }) {
  const p = usePeriodo();
  const { dados, carregando, carregou, recarregar } = useDados(buscarModulos, p.periodo, { rotulo: "os módulos" });
  useEffect(() => { definirAtualizar({ recarregar, carregando }); }, [definirAtualizar, recarregar, carregando]);

  const modulos = dados?.modulos || [];
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="flex-1 min-w-0"><FiltroPeriodo {...p} /></div>
        {modulos.length > 0 && (
          <Button variant="outline" size="sm" className="gap-2 shrink-0"
            onClick={() => exportarExcel(modulos, COLUNAS_EXCEL, `Modulos_${rotuloArquivo(p.periodo)}.xlsx`)}>
            <Download className="w-4 h-4" /> Excel
          </Button>
        )}
      </div>
      {!carregou ? <EsqueletoModulos /> : dados && (
        <Esmaecer ativo={carregando}>
          <ResumoModulos dados={dados} />
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
            {modulos.map((m) => <CardModulo key={m.key} m={m} fatTotal={dados.totais.faturamento} />)}
          </div>
          {/* Recorte do Cardápio: pedidos que a CLEO anotou pela conversa */}
          <VendasCleoPeriodo periodo={p.periodo} />
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-2">Marketplaces em breve</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
              {EM_BREVE.map((c) => <CardEmBreve key={c.key} canal={c} />)}
            </div>
          </div>
          <RankingLucro modulos={modulos} />
        </Esmaecer>
      )}
    </div>
  );
}
